/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListMcpServerAuthClientChoicesSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type ListMcpServerAuthClientChoicesRequest = {
  /**
   * The MCP server id.
   */
  mcpServerId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
};

/** @internal */
export type ListMcpServerAuthClientChoicesSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const ListMcpServerAuthClientChoicesSecurity$outboundSchema:
  z.ZodMiniType<
    ListMcpServerAuthClientChoicesSecurity$Outbound,
    ListMcpServerAuthClientChoicesSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function listMcpServerAuthClientChoicesSecurityToJSON(
  listMcpServerAuthClientChoicesSecurity:
    ListMcpServerAuthClientChoicesSecurity,
): string {
  return JSON.stringify(
    ListMcpServerAuthClientChoicesSecurity$outboundSchema.parse(
      listMcpServerAuthClientChoicesSecurity,
    ),
  );
}

/** @internal */
export type ListMcpServerAuthClientChoicesRequest$Outbound = {
  mcp_server_id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
};

/** @internal */
export const ListMcpServerAuthClientChoicesRequest$outboundSchema:
  z.ZodMiniType<
    ListMcpServerAuthClientChoicesRequest$Outbound,
    ListMcpServerAuthClientChoicesRequest
  > = z.pipe(
    z.object({
      mcpServerId: z.string(),
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        mcpServerId: "mcp_server_id",
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
      });
    }),
  );

export function listMcpServerAuthClientChoicesRequestToJSON(
  listMcpServerAuthClientChoicesRequest: ListMcpServerAuthClientChoicesRequest,
): string {
  return JSON.stringify(
    ListMcpServerAuthClientChoicesRequest$outboundSchema.parse(
      listMcpServerAuthClientChoicesRequest,
    ),
  );
}
